(function () {
  const VARIANT_CHANGE_DELAY_MS = 300;
  const COMPARE_REFRESH_DELAY_MS = 350;
  const COMPARE_CLASS = 'atc-compare-price';

  function initVariantCartMap() {
    const mapEl = document.getElementById('variant-cart-map-data');
    if (!mapEl) return;

    let map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (error) {
      console.warn('[variant-cart-map] Invalid mapping JSON', error);
      return;
    }

    const sectionId = mapEl.dataset.sectionId;
    if (!sectionId) return;

    const formSelectors = [
      `#product-form-${sectionId}`,
      `#product-form-installment-${sectionId}`,
    ];

    function getForms() {
      return formSelectors.map((selector) => document.querySelector(selector)).filter(Boolean);
    }

    function normalizeEntry(entry) {
      if (entry == null) return null;
      if (typeof entry === 'number' || typeof entry === 'string') {
        return { cartVariantId: String(entry), available: undefined };
      }
      return {
        cartVariantId: entry.cartVariantId != null ? String(entry.cartVariantId) : null,
        available: typeof entry.available === 'boolean' ? entry.available : undefined,
      };
    }

    function getEntry(sourceVariantId) {
      return normalizeEntry(map[String(sourceVariantId)]);
    }

    function resolveCartVariantId(sourceVariantId) {
      const entry = getEntry(sourceVariantId);
      if (entry && entry.cartVariantId) return entry.cartVariantId;
      return String(sourceVariantId);
    }

    function getSourceVariantId(input) {
      return input.dataset.sourceVariantId || input.dataset.selectedId || input.value;
    }

    function getVariantPicker() {
      return document.querySelector(
        `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
      );
    }

    function syncSourceVariantFromPicker() {
      const picker = getVariantPicker();
      const form = getForms()[0];
      const input = form && form.querySelector('input[name="id"]');
      if (!picker || !input) return;

      const checkedRadios = picker.querySelectorAll('input[type="radio"]:checked');
      if (!checkedRadios.length) return;

      const variantDataEl = picker.querySelector('script[type="application/json"]');
      if (!variantDataEl) return;

      try {
        const variants = JSON.parse(variantDataEl.textContent);
        const selectedOptions = Array.from(checkedRadios).map((radio) => radio.value);
        const variant = variants.find(
          (item) => JSON.stringify(item.options) === JSON.stringify(selectedOptions)
        );

        if (variant) {
          input.dataset.selectedId = String(variant.id);
          input.dataset.sourceVariantId = String(variant.id);
        }
      } catch (error) {
        console.warn('[variant-cart-map] Could not sync picker variant', error);
      }
    }

    function getDisplayVariant(sourceVariantId) {
      const picker = getVariantPicker();
      if (!picker) return null;

      const variantDataEl = picker.querySelector('script[type="application/json"]');
      if (!variantDataEl) return null;

      try {
        const variants = JSON.parse(variantDataEl.textContent);
        return variants.find((variant) => String(variant.id) === String(sourceVariantId)) || null;
      } catch (error) {
        return null;
      }
    }

    function stripHtml(str) {
      if (typeof str !== 'string') return '';
      const div = document.createElement('div');
      div.innerHTML = str;
      return (div.textContent || div.innerText || '').trim();
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';

      const format = window.themeMoneyFormat;
      if (!format || typeof format !== 'string') {
        return (cents / 100).toFixed(2);
      }

      const amount = (cents / 100).toFixed(2);
      let out = format.replace(/\{\{\s*amount\s*\}\}/gi, amount);
      const currency = window.themeCartCurrency;
      const locale = window.themeLocale || '';

      if (currency === 'AED') {
        if (locale.indexOf('ar') !== -1) {
          out = out.replace(/\bAED\b/g, 'د.إ').replace(/\bDhs\.?\s*/gi, 'د.إ');
        } else {
          out = out.replace(/\bAED\b/g, 'Dhs.');
        }
      }

      return stripHtml(out);
    }

    function getAddToCartLabel() {
      return (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    }

    function getSoldOutLabel() {
      return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    }

    function buildComparePriceHtml(displayVariant) {
      if (
        !displayVariant ||
        displayVariant.compare_at_price == null ||
        displayVariant.compare_at_price <= displayVariant.price
      ) {
        return '';
      }

      return (
        '<span class="' +
        COMPARE_CLASS +
        '" aria-hidden="true"> <span class="money">' +
        formatMoney(displayVariant.compare_at_price) +
        '</span></span>'
      );
    }

    function setButtonAvailable(button, displayVariant) {
      if (!button) return;

      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');

      const span = button.querySelector(':scope > span');
      if (!span || !displayVariant) return;

      span.innerHTML =
        '<span class="atc-title">' +
        getAddToCartLabel() +
        '</span><span class="current-price money">' +
        formatMoney(displayVariant.price) +
        '</span>' +
        buildComparePriceHtml(displayVariant);
    }

    function setButtonSoldOut(button) {
      if (!button) return;

      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');

      const span = button.querySelector(':scope > span');
      if (!span) return;

      span.innerHTML = '<span class="atc-title">' + getSoldOutLabel() + '</span>';
    }

    function refreshComparePrices() {
      if (typeof window.updateAllComparePrices === 'function') {
        setTimeout(window.updateAllComparePrices, COMPARE_REFRESH_DELAY_MS);
      }
    }

    function applyMapping(sourceVariantId) {
      const cartVariantId = resolveCartVariantId(sourceVariantId);

      getForms().forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        input.value = cartVariantId;
        input.dataset.sourceVariantId = String(sourceVariantId);
        input.dataset.cartVariantId = cartVariantId;
      });
    }

    function applyAvailabilityOverride() {
      const form = getForms()[0];
      const input = form && form.querySelector('input[name="id"]');
      const button = document.getElementById(`ProductSubmitButton-${sectionId}`);

      if (!input || !button) return;

      const sourceVariantId = getSourceVariantId(input);
      const entry = getEntry(sourceVariantId);
      const displayVariant = getDisplayVariant(sourceVariantId);

      applyMapping(sourceVariantId);

      if (!entry || typeof entry.available !== 'boolean') {
        if (displayVariant && displayVariant.available) {
          setButtonAvailable(button, displayVariant);
        } else if (displayVariant) {
          setButtonSoldOut(button);
        }
        refreshComparePrices();
        return;
      }

      if (entry.available) {
        setButtonAvailable(button, displayVariant);
        refreshComparePrices();
      } else {
        setButtonSoldOut(button);
      }
    }

    function syncFromActiveVariant() {
      syncSourceVariantFromPicker();
      const form = getForms()[0];
      const input = form && form.querySelector('input[name="id"]');
      if (!input) return;

      applyMapping(getSourceVariantId(input));
      applyAvailabilityOverride();
    }

    const variantPicker = getVariantPicker();

    if (variantPicker) {
      variantPicker.addEventListener('change', () => {
        setTimeout(syncFromActiveVariant, VARIANT_CHANGE_DELAY_MS);
      });
    }

    syncFromActiveVariant();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data && event.data.sectionId && String(event.data.sectionId) !== String(sectionId)) return;
        setTimeout(syncFromActiveVariant, VARIANT_CHANGE_DELAY_MS);
      });
    }

    getForms().forEach((form) => {
      form.addEventListener(
        'submit',
        () => {
          const input = form.querySelector('input[name="id"]');
          if (!input) return;
          applyMapping(getSourceVariantId(input));
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantCartMap);
  } else {
    initVariantCartMap();
  }
})();
